// Replacement for vue-line-clamp: v-line-clamp="3" clamps the element's text
// to N lines using the CSS line-clamp pattern.
const apply = (el, binding) => {
    const lines = parseInt(binding.value, 10)
    if (!lines || Number.isNaN(lines)) {
        el.style.display = ''
        el.style.webkitBoxOrient = ''
        el.style.webkitLineClamp = ''
        el.style.overflow = ''
        return
    }
    el.style.display = '-webkit-box'
    el.style.webkitBoxOrient = 'vertical'
    el.style.webkitLineClamp = String(lines)
    el.style.overflow = 'hidden'
}

export default {
    beforeMount: apply,
    updated: apply,
}
